import { defineFcm } from '../shared/factory';

export const FCM_DOUBLE_OPT_IN_PETITION_LIST = defineFcm('double_opt_in_petition_list')
	.asString()
	.withDefault(undefined)
	.toConfig();
